/*
 * Product gallery: two-up carousel + thumbnail strip + full-screen viewer with zoom.
 * Markup lives in sections/main-product.liquid ([data-pgal]).
 * Variant changes call thumb.click() (theme.js), so thumbs keep [data-media-id].
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pgal]');
  if (!root) return;

  var viewport = root.querySelector('[data-pgal-viewport]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pgal-slide]'));
  var thumbsBox = root.querySelector('[data-pgal-thumbs]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pgal-thumb]'));
  var prev = root.querySelector('[data-pgal-prev]');
  var next = root.querySelector('[data-pgal-next]');
  var tPrev = root.querySelector('[data-pgal-tprev]');
  var tNext = root.querySelector('[data-pgal-tnext]');
  if (!viewport || !slides.length) return;

  var current = 0;
  var ticking = false;

  function perView() {
    if (slides.length < 2) return 1;
    var first = slides[0].getBoundingClientRect().width;
    if (!first) return 1;
    return Math.max(1, Math.round(viewport.clientWidth / first));
  }

  function maxIndex() {
    return Math.max(0, slides.length - perView());
  }

  function slideLeft(i) {
    return slides[i].offsetLeft - slides[0].offsetLeft;
  }

  function goTo(i, smooth) {
    i = Math.max(0, Math.min(i, maxIndex()));
    viewport.scrollTo({ left: slideLeft(i), behavior: smooth === false ? 'auto' : 'smooth' });
    setCurrent(i);
  }

  function indexFromScroll() {
    var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : viewport.clientWidth;
    if (!step) return 0;
    return Math.max(0, Math.min(Math.round(viewport.scrollLeft / step), slides.length - 1));
  }

  function setCurrent(i) {
    current = i;
    var pv = perView();
    thumbs.forEach(function (t, n) {
      var on = n >= i && n < i + pv;
      t.classList.toggle('is-active', on);
      if (n === i) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    var max = maxIndex();
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= max;
    root.classList.toggle('pgal--no-arrows', max === 0);
    keepThumbVisible(i);
  }

  function keepThumbVisible(i) {
    if (!thumbsBox || !thumbs[i]) return;
    var t = thumbs[i].parentElement;
    var target = t.offsetLeft - (thumbsBox.clientWidth - t.offsetWidth) / 2;
    thumbsBox.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  function updateThumbArrows() {
    if (!thumbsBox) return;
    var over = thumbsBox.scrollWidth > thumbsBox.clientWidth + 2;
    var atStart = thumbsBox.scrollLeft <= 2;
    var atEnd = thumbsBox.scrollLeft + thumbsBox.clientWidth >= thumbsBox.scrollWidth - 2;
    var wrap = thumbsBox.parentElement;
    wrap.classList.toggle('has-overflow', over);
    wrap.classList.toggle('at-start', atStart);
    wrap.classList.toggle('at-end', atEnd);
    if (tPrev) tPrev.hidden = !over || atStart;
    if (tNext) tNext.hidden = !over || atEnd;
  }

  viewport.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = indexFromScroll();
        if (i !== current) setCurrent(i);
      });
    },
    { passive: true }
  );

  if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
  if (next) next.addEventListener('click', function () { goTo(current + 1); });

  viewport.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
  });

  thumbs.forEach(function (thumb, n) {
    thumb.addEventListener('click', function () { goTo(n); });
  });

  if (thumbsBox) {
    thumbsBox.addEventListener('scroll', updateThumbArrows, { passive: true });
    if (tPrev) tPrev.addEventListener('click', function () {
      thumbsBox.scrollBy({ left: -thumbsBox.clientWidth * 0.8, behavior: 'smooth' });
    });
    if (tNext) tNext.addEventListener('click', function () {
      thumbsBox.scrollBy({ left: thumbsBox.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  window.addEventListener('resize', function () {
    setCurrent(Math.min(current, maxIndex()));
    updateThumbArrows();
  });

  /* ---------------------------------------------------------------- */
  /* Full-screen viewer                                                */
  /* ---------------------------------------------------------------- */
  var items = [];
  slides.forEach(function (slide, n) {
    var btn = slide.querySelector('[data-pgal-open]');
    if (!btn) return;
    items.push({
      slideIndex: n,
      full: btn.getAttribute('data-full'),
      thumb: btn.getAttribute('data-thumb'),
      alt: btn.getAttribute('data-alt') || ''
    });
    btn.addEventListener('click', function () { openViewer(items.length - 1 >= 0 ? itemIndexForSlide(n) : 0, btn); });
  });

  function itemIndexForSlide(n) {
    for (var k = 0; k < items.length; k++) if (items[k].slideIndex === n) return k;
    return 0;
  }

  var viewer = null;
  var vImg, vPan, vCount, vThumbs, vPrev, vNext, vClose;
  var vIndex = 0;
  var zoomed = false;
  var lastFocus = null;
  var touchX = null;

  function buildViewer() {
    viewer = document.createElement('div');
    viewer.className = 'plb';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Product images');
    viewer.hidden = true;
    viewer.innerHTML =
      '<div class="plb__top"><span class="plb__count" aria-live="polite"></span>' +
      '<span class="plb__hint">Click the image to zoom</span>' +
      '<button type="button" class="plb__close" aria-label="Close">&times;</button></div>' +
      '<button type="button" class="plb__arrow plb__arrow--prev" aria-label="Previous image">&lsaquo;</button>' +
      '<button type="button" class="plb__arrow plb__arrow--next" aria-label="Next image">&rsaquo;</button>' +
      '<div class="plb__stage"><div class="plb__pan"><img class="plb__img" alt=""></div></div>' +
      '<div class="plb__thumbs"></div>';
    document.body.appendChild(viewer);

    vImg = viewer.querySelector('.plb__img');
    vPan = viewer.querySelector('.plb__pan');
    vCount = viewer.querySelector('.plb__count');
    vThumbs = viewer.querySelector('.plb__thumbs');
    vPrev = viewer.querySelector('.plb__arrow--prev');
    vNext = viewer.querySelector('.plb__arrow--next');
    vClose = viewer.querySelector('.plb__close');

    items.forEach(function (it, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'plb__thumb';
      b.setAttribute('aria-label', 'Image ' + (k + 1));
      var im = document.createElement('img');
      im.src = it.thumb;
      im.alt = '';
      b.appendChild(im);
      b.addEventListener('click', function () { show(k); });
      vThumbs.appendChild(b);
    });

    vClose.addEventListener('click', closeViewer);
    vPrev.addEventListener('click', function () { show(vIndex - 1); });
    vNext.addEventListener('click', function () { show(vIndex + 1); });

    viewer.addEventListener('click', function (e) {
      if (e.target === viewer || e.target.classList.contains('plb__stage') || e.target === vPan) {
        if (zoomed) setZoom(false);
        else closeViewer();
      }
    });

    vImg.addEventListener('click', function (e) {
      if (zoomed) setZoom(false);
      else setZoom(true, e);
    });

    vPan.addEventListener('mousemove', function (e) {
      if (!zoomed) return;
      var r = vPan.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width;
      var fy = (e.clientY - r.top) / r.height;
      vPan.scrollLeft = fx * (vPan.scrollWidth - vPan.clientWidth);
      vPan.scrollTop = fy * (vPan.scrollHeight - vPan.clientHeight);
    });

    viewer.addEventListener('touchstart', function (e) {
      touchX = !zoomed && e.touches.length === 1 ? e.touches[0].clientX : null;
    }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 50) show(vIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!viewer || viewer.hidden) return;
      if (e.key === 'Escape') closeViewer();
      else if (e.key === 'ArrowRight') show(vIndex + 1);
      else if (e.key === 'ArrowLeft') show(vIndex - 1);
      else if (e.key === 'Tab') {
        var focusables = viewer.querySelectorAll('button:not([disabled])');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function setZoom(on, evt) {
    zoomed = on;
    viewer.classList.toggle('is-zoomed', on);
    if (on) {
      var r = vImg.getBoundingClientRect();
      var fx = evt ? (evt.clientX - r.left) / r.width : 0.5;
      var fy = evt ? (evt.clientY - r.top) / r.height : 0.5;
      vImg.style.width = Math.round(vPan.clientWidth * 2.4) + 'px';
      vImg.style.maxWidth = 'none';
      vImg.style.maxHeight = 'none';
      vPan.scrollLeft = fx * vImg.offsetWidth - vPan.clientWidth / 2;
      vPan.scrollTop = fy * vImg.offsetHeight - vPan.clientHeight / 2;
    } else {
      vImg.style.width = '';
      vImg.style.maxWidth = '';
      vImg.style.maxHeight = '';
      vPan.scrollLeft = 0;
      vPan.scrollTop = 0;
    }
  }

  function show(k) {
    if (k < 0 || k >= items.length) return;
    vIndex = k;
    if (zoomed) setZoom(false);
    vImg.src = items[k].full;
    vImg.alt = items[k].alt;
    vCount.textContent = k + 1 + ' / ' + items.length;
    vPrev.disabled = k === 0;
    vNext.disabled = k === items.length - 1;
    Array.prototype.forEach.call(vThumbs.children, function (b, n) {
      b.classList.toggle('is-active', n === k);
      if (n === k) {
        vThumbs.scrollTo({
          left: Math.max(0, b.offsetLeft - (vThumbs.clientWidth - b.offsetWidth) / 2),
          behavior: 'smooth'
        });
      }
    });
    /* keep the page carousel in sync */
    goTo(items[k].slideIndex);
  }

  function openViewer(k, trigger) {
    if (!items.length) return;
    if (!viewer) buildViewer();
    lastFocus = trigger || document.activeElement;
    viewer.hidden = false;
    document.documentElement.classList.add('plb-open');
    show(k);
    vClose.focus();
  }

  function closeViewer() {
    if (!viewer) return;
    if (zoomed) setZoom(false);
    viewer.hidden = true;
    document.documentElement.classList.remove('plb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------------- */
  var start = parseInt(root.getAttribute('data-start') || '0', 10) || 0;
  window.requestAnimationFrame(function () {
    goTo(start, false);
    updateThumbArrows();
  });
})();
